import { render } from "./ManagerIntegration.vue?vue&type=template&id=0a937588"
import script from "./ManagerIntegration.vue?vue&type=script&lang=js"
export * from "./ManagerIntegration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__